import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelize } from 'src/utils/decamelize';

import { denormalize } from '../shared/normalizers';

import { FetchScheduleOption, ScheduleItem } from './_types';

export const fetchScheduleQueryKey = (o: FetchScheduleOption) => [
  'clients',
  o.sortBy,
  o.sortDir,
  o.page,
  o.perPage,
  o.search,
  o.filters,
];

const fetchSchedules = async ({
  page = 1,
  perPage = 20,
  filters = {},
  sortBy = '',
  sortDir = '',
}: FetchScheduleOption = {}): Promise<{
  schedules: ScheduleItem[];
  total: number;
}> => {
  const response = await api.get(`/api/v4/fbm/schedules`, {
    params: {
      for_user: true,
      page: page,
      per: perPage,
      ...(sortBy && {
        'q[s]': `${decamelize(sortBy || '')} ${sortDir || 'desc'}`,
      }),
      ...(filters.trainerId && { 'q[has_trainer]': filters.trainerId }),
      ...(filters.location && { 'q[location_id_eq]': filters.location }),
      ...(filters.service && { 'q[services_id_eq]': filters.service }),
      ...(filters.status && { 'q[has_status]': filters.status }),
    },
  });
  return {
    schedules: response.data.schedule.map((schedule) => {
      return camelcaseKeys(schedule, { deep: true });
    }),
    total: response.data.meta.total,
  };
};

const fetchSchedule = async (id: Identifier): Promise<ScheduleItem> => {
  const response = await api.get(`/api/v4/fbm/schedules/${id}`);
  return camelcaseKeys(response.data, { deep: true });
};

const createSchedule = async (
  data: Partial<ScheduleItem>
): Promise<ScheduleItem> => {
  const response = await api.post(`/api/v4/fbm/schedules`, {
    schedule: denormalize(data),
  });
  return camelcaseKeys(response.data, { deep: true });
};

const updateSchedule = async (
  id: Identifier,
  data: Partial<ScheduleItem>
): Promise<ScheduleItem> => {
  const response = await api.put(`/api/v4/fbm/schedules/${id}`, {
    schedule: denormalize(data),
  });
  return camelcaseKeys(response.data, { deep: true });
};

const deleteSchedule = async (id: Identifier): Promise<void> => {
  await api.delete(`/api/v4/fbm/schedules/${id}`);
};

export {
  fetchSchedules,
  fetchSchedule,
  createSchedule,
  updateSchedule,
  deleteSchedule,
};
